import { useDispatch } from 'react-redux';
import { MODEL_TYPES } from '../../constants/constants';
import { useProductActions } from '../../hooks/useProductActions';
import { useTextureActions } from '../../hooks/useTextureActions';
import { setShareProductPage } from '../../redux/slicers/productV2Slicer';

function useProductV2Actions({ productInfo, isTexture = false }) {
  const dispatch = useDispatch()
  const { favouriteLoading, onFavouriteToggle, onShare, addToCollection } = isTexture
    ? useTextureActions({
        item: productInfo,
        modelType: MODEL_TYPES.TEXTURE,
      })
    : useProductActions({
        item: productInfo,
        modelType: MODEL_TYPES.PRODUCT,
      });

  const handleAddCollection = () => addToCollection(productInfo);

  const handleToggleFavourite = ({ callback } = {}) => {
    onFavouriteToggle()();
    setTimeout(() => callback?.(), 1000);
  };

  const handleShareProduct = () => {
    onShare(productInfo);
    if (+window.$shareItem?.[isTexture ? 'texture' : 'product'] !== +productInfo?.id) {
      window.$shareItem = null;
      window.$shareFlag = false;
    }
  };

  const handleShareProductPage = (e, info) => {
    if (!info) return
    dispatch(setShareProductPage(info));
    // if (+window.$shareItem?.[isTexture ? 'texture' : 'product'] !== +productInfo?.id) {
    //   window.$shareItem = null;
    //   window.$shareFlag = false;
    // }
  };

  return {
    handleAddCollection,
    handleShareProduct,
    handleShareProductPage,
    favouriteLoading,
    handleToggleFavourite,
  };
}

export default useProductV2Actions;
